import Ladehinweis from '../../komponenten/Ladehinweis'
import { datum, useLaden } from '../../lib/laden'
import { HERKUNFT_TEXT, holeGoogleFelder, holeHerkunft } from '../../lib/kennzahlen'

/**
 * Welches Feld an einem Ort stammt woher, und unter welcher Lizenz?
 *
 * Der Bildschirm ist unspektakulär — bis die Frage aufkommt, ob irgendwo ein
 * Inhalt steht, der nicht stehen darf.
 */
export default function Herkunft() {
  const [uebersicht] = useLaden(holeHerkunft)
  const [google] = useLaden(holeGoogleFelder)

  return (
    <section className="stapel">
      <div className="stapel-kopf">
        <h1>Herkunft und Lizenz</h1>
      </div>

      {/* Die eigentliche Frage zuerst — nicht die schöne Tabelle. */}
      <div className="karte">
        <h2>Steht unter Google etwas, das dort nicht stehen darf?</h2>
        <p className="gedaempft">
          Die Nutzungsbedingungen der Google Maps Platform erlauben, eine
          Place-ID unbegrenzt zu speichern — Bewertungen und Textinhalte nicht.
          Solange hier nur <span className="zahl">googlePlaceId</span> steht,
          ist alles in Ordnung.
        </p>

        {google.art !== 'da' ? (
          <Ladehinweis zustand={google} />
        ) : google.wert.auffaellig.length === 0 ? (
          <p className="meldung meldung-erfolg" role="status">
            Nur <span className="zahl">googlePlaceId</span> — genau so soll es
            aussehen.
          </p>
        ) : (
          <>
            <p className="meldung meldung-fehler" role="alert">
              <strong>{google.wert.auffaellig.length} Felder</strong> unter{' '}
              <span className="zahl">google</span>, die keine Place-ID sind. Das
              gehört angesehen, und zwar bevor jemand danach fragt.
            </p>
            <div className="tabelle-huelle">
              <table className="tabelle">
                <thead>
                  <tr>
                    <th>Ort</th>
                    <th>Stadt</th>
                    <th>Feld</th>
                    <th>Lizenz</th>
                    <th>übernommen</th>
                  </tr>
                </thead>
                <tbody>
                  {google.wert.auffaellig.map((f) => (
                    <tr key={`${f.id}:${f.field_path}`} className="anders">
                      <td>{f.name ?? 'ohne Namen'}</td>
                      <td className="leise">{f.city ?? '—'}</td>
                      <td className="zahl wort-ab">{f.field_path}</td>
                      <td className="leise">{f.license ?? '—'}</td>
                      <td className="leise">{datum(f.acquired_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <div className="karte">
        <h2>Der ganze Bestand nach Herkunft</h2>
        {uebersicht.art !== 'da' ? (
          <Ladehinweis zustand={uebersicht} />
        ) : (
          <div className="tabelle-huelle">
            <table className="tabelle">
              <thead>
                <tr>
                  <th>Herkunft</th>
                  <th>Lizenz</th>
                  <th>Felder</th>
                  <th>Orte</th>
                  <th>welche Felder</th>
                </tr>
              </thead>
              <tbody>
                {uebersicht.wert.zeilen.map((z) => (
                  <tr key={`${z.origin}:${z.license}`}>
                    <td>{HERKUNFT_TEXT[z.origin] ?? z.origin}</td>
                    <td className="leise">{z.license ?? '—'}</td>
                    <td className="zahl">{z.felder.toLocaleString('de-DE')}</td>
                    <td className="zahl leise">{z.orte.toLocaleString('de-DE')}</td>
                    <td className="leise zahl">{z.felder_namentlich.join(', ')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  )
}
